import Breadcrumb from "components/Common/Breadcrumb";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import QwikSelect from "components/form/QwikSelect";
import React from "react";
import { Col, Container, Row } from "reactstrap";
import {
  useCreateJobMutation,
} from "store/features/jobs/jobManagementApi";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

const CreateJob = () => {
  const [createJob, { isLoading }] = useCreateJobMutation();
  const navigate = useNavigate();

  const handleSubmit = async data => {
    try {
      // Prepare form data
      const formData = {
        title: data.title,
        position: data.position,
        company: data.company,
        location: data.location,
        duration: data.duration || "",
        date: data.date || new Date().toISOString().split('T')[0],
        jobcatagory: data.jobcatagory,
        aboutpossitiondetails: data.aboutpossitiondetails || "",
        requirementsdetails: data.requirementsdetails || "",
        responsibilites: data.responsibilites || "",
        employeebanifits: data.employeebanifits || "",
        joboffer: data.joboffer || "",
        jobdetails: data.jobdetails || "",
        applyprocess: data.applyprocess || "",
        appicationDuration: data.appicationDuration || "",
        type: data.type || "",
        likes: data.likes || "0",
      };

      await createJob(formData).unwrap();

      setTimeout(() => {
        navigate("/all-jobs");
      }, 1500);
    } catch (error) {
      toast.error("Failed to create job");
      console.error("Job creation error:", error);
    }
  };

  return (
    <div className="page-content px-4">
      <Container fluid={true}>
        <Breadcrumb title="Jobs" breadcrumbItem="Create Job" />
        <Row>
          <QwikForm onSubmit={handleSubmit}>
            <Col className="col-12">
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="title"
                      label="Job Title"
                      placeholder="Enter job title"
                      type="text"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikSelect
                      name="position"
                      label="Position Type"
                      options={[
                        { value: "Full Time Permanent", label: "Full Time Permanent" },
                        { value: "Internship", label: "Internship" },
                        { value: "Contract", label: "Contract" },
                        { value: "Part-time", label: "Part-time" },
                      ]}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="company"
                      label="Company"
                      placeholder="Enter company name"
                      type="text"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="location"
                      label="Location"
                      placeholder="Enter job location"
                      type="text"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="duration"
                      label="Duration"
                      placeholder="e.g., 3 Months, Permanent"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="date"
                      label="Posted Date"
                      type="date"
                      className="form-control"
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikSelect
                      name="jobcatagory"
                      label="Job Category"
                      options={[
                        { value: "Remote", label: "Remote" },
                        { value: "Onsite", label: "On-site" },
                        { value: "Hybrid", label: "Hybrid" },
                        { value: "Contract", label: "Contract" },
                        { value: "Internship", label: "Internship" },
                      ]}
                      required
                    />
                  </div>
                </Col>

                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="likes"
                      label="Likes Count"
                      placeholder="Enter likes count"
                      type="number"
                      className="form-control"
                    />
                  </div>
                </Col> */}

                {/* Text Area Fields */}
                <Col lg={12}>
                  <div className="mb-3">
                    <QwikInput
                      name="aboutpossitiondetails"
                      label="About Position Details"
                      placeholder="Enter details about the position..."
                      type="textarea"
                      className="form-control"
                      rows="3"
                    />
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <QwikInput
                      name="requirementsdetails"
                      label="Requirements Details"
                      placeholder="Enter job requirements..."
                      type="textarea"
                      className="form-control"
                      rows="3"
                    />
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <QwikInput
                      name="responsibilites"
                      label="Responsibilities"
                      placeholder="Enter job responsibilities..."
                      type="textarea"
                      className="form-control"
                      rows="3"
                    />
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <QwikInput
                      name="employeebanifits"
                      label="Employee Benefits"
                      placeholder="Enter employee benefits..."
                      type="textarea"
                      className="form-control"
                      rows="3"
                    />
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <QwikInput
                      name="joboffer"
                      label="Job Offer Details"
                      placeholder="Enter job offer details..."
                      type="textarea"
                      className="form-control"
                      rows="3"
                    />
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <QwikInput
                      name="jobdetails"
                      label="Job Details"
                      placeholder="Enter additional job details..."
                      type="textarea"
                      className="form-control"
                      rows="3"
                    />
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <QwikInput
                      name="applyprocess"
                      label="Application Process"
                      placeholder="Enter application process..."
                      type="textarea"
                      className="form-control"
                      rows="3"
                    />
                  </div>
                </Col>

                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="appicationDuration"
                      label="Application Duration"
                      placeholder="e.g., 30 days"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col> */}

                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="type"
                      label="Job Type"
                      placeholder="e.g., Technical, Marketing"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col> */}

                <div className="col-sm-6 text-start mt-4">
                  <button
                    className="btn btn-primary w-md waves-effect waves-light"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "Creating..." : "Create Job"}
                  </button>
                </div>
              </Row>
            </Col>
          </QwikForm>
        </Row>
      </Container>
    </div>
  );
};

export default CreateJob;